export const _ADD                   = "trPBYPICKobelsEVONHljQ==";
export const _EDIT                  = "ZGZRgIkvaqEkqqDYqn8Zrg==";
export const _VIEW                  = "2++3jIKNar/r8+QNCsXL9Q==";
export const _DELETE                = "+uhEIK/JePLfJkTWDK8fSNPP6ltcCLqa1jk3MYYuaXw=";
export const _RECOVER               = "Lj+gjBtNrnernTXMm6p+CLNkaTM/ZQjw1NEAtySZ1eU=";
export const _LIST                  = "0bNKT0YhWIvZwf2RYoP+qQ==";
export const _TRASH                 = "ZFIKr9VJxAyHF42PGZeYEt8SIQWxwtVC71ercUtJgjE=";